import { fetchAccessTokenIfNeeded } from '~/AccessToken';
import { findPrices } from '~/Api/User/DatasourceComputedPrice';
import { invokeApi } from '~/ApiClient';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchPrices(userId: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findPrices, userId));
		dispatch({ type: ActionTypes.request, userId, request });

		try {
			const response = await request;
			dispatch({ type: ActionTypes.receive, request, prices: response.items });
		} catch (error) {
			dispatch({ type: ActionTypes.receive, request, prices: null });
			throw error;
		}
	};
}

export function fetchPricesIfNeeded(): ThunkAction<Promise<void>, any> {
	return async (dispatch, getState) => {
		const userId = (await dispatch(fetchAccessTokenIfNeeded())).accessToken.user.id;
		const state = getState().datasourceComputedPrice;

		if (state.userId === userId && state.request) {
			await state.request;
			return;
		}
		await dispatch(fetchPrices(userId));
	};
}
